// extracted by mini-css-extract-plugin
module.exports = {"videoPlayer":"Video_videoPlayer__NarXV","preview":"Video_preview__8efwY","btnPlay":"Video_btnPlay__pIkqk","video":"Video_video___HEi8","fadeIn":"Video_fadeIn__41KCd"};